export const fetchTrackingStore = (url: string, event: string, data: object, fetchData: any, apiLoading: any, apiSuccess: any, apiError: any) => {
    const { content }: any = data
    
    fetchData(url,'POST', {
      "event": event,
      "content": {...content}
    }, {}, apiLoading, apiSuccess, apiError);
}
  